import { jsxs, jsx } from "react/jsx-runtime";
import { useCallback, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useIMask } from "react-imask";
import { FormControlLabel, Checkbox } from "@mui/material";
import { ControlItem, RadioTypography } from "../appointment-status-select/appointment-status-select.styles.js";
import { toTimeString } from "../../../../../utils/time/time.js";
import { useDebouncedCallback } from "use-debounce";
import { INPUT_DELAY } from "../appointment-status-select/appointment-status-select.constants.js";
import { StyledTextField } from "./appointment-status-controlled.styles.js";
import "@mui/icons-material";
import "@mui/material/styles";
import "date-fns";
const maskDefaultProps = {
  mask: "00{:}00",
  overwrite: true,
  min: 4
};
const AppointmentStatusControlled = ({ label, name, onFormChange }) => {
  const { register, setValue, handleSubmit, watch } = useFormContext();
  const watchTime = watch(name);
  const debouncedHandleTimeChange = useDebouncedCallback(
    (data, isManualInput) => onFormChange(isManualInput)(data),
    INPUT_DELAY
  );
  const handleTimeChange = useCallback(
    async (value, isManualInput = true) => {
      setValue(name, value);
      await handleSubmit((data) => debouncedHandleTimeChange(data, isManualInput))();
    },
    [handleSubmit, debouncedHandleTimeChange, setValue]
  );
  const {
    ref: timeInputRef,
    value: timeValue,
    setValue: setTimeMaskValue
  } = useIMask(maskDefaultProps, {
    onComplete: (value) => handleTimeChange(value)
  });
  useEffect(() => {
    if (watchTime !== timeValue)
      setTimeMaskValue(watchTime ?? "");
  }, [watchTime, setTimeMaskValue]);
  useEffect(() => {
    const setInitialStateControlledTime = async () => {
      if (!watchTime && name === "stateControlled") {
        await handleTimeChange(toTimeString(/* @__PURE__ */ new Date()), false);
      }
    };
    setInitialStateControlledTime();
  }, [name, setValue, handleTimeChange]);
  const handleChange = async (event) => {
    if (!event.target.checked) {
      await handleTimeChange(null, false);
    } else {
      await handleTimeChange(toTimeString(/* @__PURE__ */ new Date()), false);
    }
  };
  return /* @__PURE__ */ jsxs(ControlItem, { children: [
    /* @__PURE__ */ jsx(
      FormControlLabel,
      {
        label: /* @__PURE__ */ jsxs(RadioTypography, { variant: "Lato Body 2", children: [
          " ",
          label,
          " "
        ] }),
        control: /* @__PURE__ */ jsx(Checkbox, { checked: !!watchTime, name, onChange: handleChange, value: !!watchTime })
      }
    ),
    /* @__PURE__ */ jsx(
      StyledTextField,
      {
        ...register(name),
        disabled: !watchTime,
        inputRef: timeInputRef,
        variant: "outlined",
        value: timeValue
      }
    )
  ] }, name);
};
export {
  AppointmentStatusControlled as default
};
